
























import { Component, Vue } from 'vue-property-decorator';
import MpCookieBanner from '@/components/controls/mp-cookie-banner/MpCookieBanner.vue';
@Component({
  components: { MpCookieBanner }
})
export default class DefaultAppLayout extends Vue {}
